export enum MonitoringSystem {
  TrackCircuit = 'TrackCircuit',
  PointMachine = 'PointMachine',
  SwitchHeat = 'SwitchHeat',
  SignalEarthFault = 'SignalEarthFault',
  MachineHeat = 'MachineHeat',
}
